export enum LocalStorage {
    /**
     * {@link State.View.showExtendedView}
     */
    SHOW_EXTENDED_VIEW = "showExtendedView",

    /**
     * Represents the unique identifier of the last chat that was processed or interacted with.
     * Typically used in applications that handle real-time messaging or interactions to keep track of
     * the most recent chat session.
     *
     * This variable may be updated dynamically as new chat interactions occur, ensuring the
     * system is aware of the latest chat context.
     */
    LAST_CHAT_ID = "lastChatId",
    LAST_CHAT_NAME = "lastChatName",

    REMEMBERED_EMAIL = "rememberedEmail",

    AUTH_TOKEN = "authToken",
    USER_ID = "userId",
    USER_EMAIL = "userEMail",

    /**
     * Stores chat input values with their chat ID for persistence
     */
    CHAT_INPUT_VALUES = "chatInputValues",
}

/**
 * TODO Soll perspektivisch durch i18n ersetzt werden.
 */
export enum Label {
    SEARCH = "Suche",
    ESGBOT = "ESGbot",
    CHAT = "Chat",
    KNOWLEDGE = "Wissen",
    ABOUT = "Über",
    AI_SERVICES = "KI-Services",
    PRIVACY = "Datenschutzrichtlinie",
    LEGAL = "Impressum",
    COOKIES = "Cookies",
    EXPENSES = "Ausgaben",
    LAST_CHATS = "Letzte Chats",
}

export enum QueryKey {
    FAVORITES = "favorites",
    CHATS = "chats",
    DOCUMENTS = "documents",
    PROFILE = "profile",
    MESSAGES = "messages",
    DOCUMENTS_SELECTION_IDS = "documentsSelectionIDs",
    DOCUMENTS_SELECTION = "documentsSelection",
}
